import { jsxs, jsx } from 'react/jsx-runtime';
import { IconComment, IconBin } from '@fabric-app/icons/old';
import { reactToHTML } from '@fabric-app/ui/utils/reactToHTML';
import { styled } from 'styled-components';

const FloatingActionsItem = styled.button.withConfig({
  displayName: "FloatingActions__FloatingActionsItem",
  componentId: "sc-f908297e-0"
})([
  `height:inherit;background:none;padding:11px 8px;display:flex;justify-content:center;align-items:center;cursor:pointer;border:none;color:#fff;z-index:10;margin-left:0px;`
]);
const FloatingActionsArrow = styled.span.withConfig({
  displayName: "FloatingActions__FloatingActionsArrow",
  componentId: "sc-f908297e-1"
})([
  `position:absolute;top:100%;left:50%;transform:translateX(-50%);`
]);
const FloatingActionsContent = styled.div.withConfig({
  displayName: "FloatingActions__FloatingActionsContent",
  componentId: "sc-f908297e-2"
})([
  `display:flex;background:black;border:1px solid #ffffff;align-items:center;border-radius:6px;padding:3px;height:40px;> `,
  `::before{content:'';position:absolute;display:block;width:20px;height:20px;background:#000;border-bottom:1px solid #fff;border-right:1px solid #fff;transform:rotate(50deg) skewX(10deg) translate(-80%,2px);left:15%;}`
], FloatingActionsArrow);
const FloatingActionsRender = reactToHTML(/* @__PURE__ */ jsxs(FloatingActionsContent, {
  children: [
    /* @__PURE__ */ jsx(FloatingActionsItem, {
      "data-annotation-action": "comment",
      children: /* @__PURE__ */ jsx(IconComment, {})
    }),
    /* @__PURE__ */ jsx(FloatingActionsItem, {
      "data-annotation-action": "delete",
      children: /* @__PURE__ */ jsx(IconBin, {})
    }),
    /* @__PURE__ */ jsx(FloatingActionsArrow, {})
  ]
}));
const FloatingActions = {
  Item: FloatingActionsItem,
  Content: FloatingActionsContent,
  Arrow: FloatingActionsArrow,
  Render: FloatingActionsRender
};

export { FloatingActions, FloatingActionsArrow, FloatingActionsContent, FloatingActionsItem, FloatingActionsRender };
//# sourceMappingURL=FloatingActions.js.map
